import { CommonModule } from '@angular/common';

import { Select, Store } from '@ngxs/store';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SidenavService } from '../../../../../shared/services/sidenav.service';
import { SharedModule } from '../../../../../shared/shared.module';
import { ButtonColors, ButtonModule } from '@ed---interne/ng-uui-components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderService } from 'src/app/shared/services/header.service';
import { formatDate, TimesheetsState, UpdateTimesheets } from '../../timesheet.state';
import { Observable } from 'rxjs';
import { TimesheetModel } from '../../timesheet.models';
import { TimesheetGridCardComponent } from '../timesheet-grid-card/timesheet-grid-card.component';
import {
    GetProjectById,
    GetProjectByPhaseId,
    GetProjects,
    ProjectsState,
} from '../../../project/project.state';
import { ProjectModel } from '../../../project/project.models';
import { ActivatedRoute, Router } from '@angular/router';

@UntilDestroy()
@Component({
    selector: 'app-timesheet-edit',
    templateUrl: './timesheet-edit.component.html',
    styleUrls: ['./timesheet-edit.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        FormsModule,
        ButtonModule,
        TimesheetGridCardComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TimesheetEditComponent {
    ButtonColors = ButtonColors;

    @Select(TimesheetsState.timesheets)
    public timesheets$!: Observable<TimesheetModel[]>;
    public timesheets: TimesheetModel[] = [];

    @Select(ProjectsState.allProjects)
    public projects$!: Observable<ProjectModel[]>;
    public projects: ProjectModel[] = [];

    @Select(TimesheetsState.isLoading)
    public isLoading$!: Observable<boolean>;
    public isLoading = true;

    @Select(TimesheetsState.range)
    public range$!: Observable<{ from: Date; to: Date }>;
    public range: { from: Date; to: Date } | undefined = undefined;

    public isEditing: boolean = false;
    public canEdit: boolean = true;

    constructor(
        private headerService: HeaderService,
        private sidenavService: SidenavService,
        private store: Store,
        private router: Router,
        private route: ActivatedRoute,
    ) {
        this.headerService.setBreadcrumbs([
            { label: 'Feuilles de temps' },
            { label: 'La plus récente' },
        ]);

        this.sidenavService.resetSubMenuItem('Feuilles de temps', [
            {
                label: `Ma feuille de temps`,
                icon: 'icon-clock-stopwatch',
                routerLink: [`/main/timesheet/`],
                routerLinkActiveOptions: { exact: true },
                hidden: false,
                isActive: false,
                subItems: [],
            },
            {
                label: `Mes contributions`,
                icon: 'icon-calendar',
                routerLink: [`/main/timesheet/contributor/`],
                routerLinkActiveOptions: { exact: true },
                hidden: false,
                isActive: false,
                subItems: [],
            },
        ]);
        this.projects$
            .pipe(untilDestroyed(this))
            .subscribe((projects) => (this.projects = projects));
        this.range$.pipe(untilDestroyed(this)).subscribe((range) => (this.range = range));
        this.isLoading$
            .pipe(untilDestroyed(this))
            .subscribe((isLoading) => (this.isLoading = isLoading));
        this.timesheets$.pipe(untilDestroyed(this)).subscribe((timesheets) => {
            if (!this.isEditing && timesheets?.length > 0) {
                this.timesheets = timesheets;
                console.log('timesheets changeed');
                const date = this.timesheets[0].date;
                this.headerService.setBreadcrumbs([
                    { label: 'Feuilles de temps' },
                    { label: date.toLocaleDateString() },
                ]);
            }
            this.canEdit = !this.isCompleted();
        });
    }

    isCompleted() {
        return !this.timesheets.find(
            (t) => 1 !== t.dailyTimeEntries.reduce((acc, e) => acc + Number(e.percentOfDay), 0),
        );
    }
    onSearchProject(query: any) {
        if (query.q) this.store.dispatch(new GetProjects({ pagination: { q: query.q } }));
        if (query.projectId)
            this.store.dispatch(new GetProjectById({ projectId: query.projectId }));
        if (query.phaseId) this.store.dispatch(new GetProjectByPhaseId({ phaseId: query.phaseId }));
    }

    onEdit(b: boolean) {
        this.isEditing = b;
    }

    save(timesheets: TimesheetModel[]) {
        this.store.dispatch(new UpdateTimesheets({ timesheets }));
        this.isEditing = false;
        this.timesheets = [];
    }

    onClickPreviousTimesheet = () => {
        if (!this.range?.from) return;
        const date = new Date(this.range?.from);
        date.setDate(date.getDate() - 7);
        this.navigateToDate(date);
    };
    onClickNextTimesheet = () => {
        if (!this.range?.from) return;
        const date = new Date(this.range?.from);
        date.setDate(date.getDate() + 7);
        this.navigateToDate(date);
    };

    navigateToDate(date: Date) {
        const userid = this.route.snapshot.params['userid'];
        const ddmmyyyy = formatDate(date);
        const path = `/main/timesheet/sheet/${userid ? userid + '/' : ''}${ddmmyyyy}`;
        this.router.navigateByUrl(path);
    }

    preventExitWithoutSaving = () => {};
}
